import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild} from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { environment } from "src/environments/environment";
import * as CONSTANT from "../../../services/constants";

@Component({
  selector: "app-add-licenese",
  templateUrl: "./add-licenese.component.html",
  styleUrls: ["./add-licenese.component.css"]
})
export class AddLiceneseComponent implements OnInit {
  modalRef?: BsModalRef;
  form: FormGroup;
  showError = false;
  // uni&spec
  allData:any=[];
  // datepicker
  minDate = new Date();
  // minDate: Date;
	maxDate = new Date();
	today: Date | undefined;
  title= "Add";
  editId=""
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService) {
    this.form = this.formBuilder.group({
      id: [""],
      name: ["", Validators.compose([Validators.required])],
      attestedByAuthority: ["", Validators.compose([Validators.required])],
      credentialUrl: ["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],
      certificationNo: [""],
      issuesedOn: [""],
      expirydate: [""],
    });
    this.minDate = new Date();
   }
   onDateChange(event: Date) { 
  }
   ngOnInit(): void {
    this.getDetail();
  }
  // date picker only accpedct number
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d+$/.test(key)) {
      event.preventDefault();
    }
  }
  getDetail(){
    this.api.getDatas(apiUrl._getLiences)
    .subscribe(async (res) => {
      this.allData = res.data;
      if(res.data != ""){
        this.router.navigate(["/licenese/add"]);
      } else{
        this.router.navigate(["/licenese"]);
      }
    })
  }
  openModal(template: TemplateRef<any>) {
    this.editId="" 
    this.form.reset()
    this.title ="Add"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal maxWidth" })
    );
  }

  closeModal(){
    this.editId="" 
   this.modalService.hide();
  }
  // edit
  edit(data,template: TemplateRef<any>){
    this.editId =data.id;
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal maxWidth" })
    ); 
    
    setTimeout(() => {
      this.form.patchValue({
        ...data,
        issuesedOn:data.issuesedOn ? new Date(data.issuesedOn) : "",
        expirydate:data.expirydate ? new Date(data.expirydate): "",
      })
    }, 500);
  }
// delete
delete(id){
  const data={"id":id}
  this.api.deleteData(apiUrl._delLiences,data)
    .subscribe(async (res) => { 
      this.toastrService.success("", "licenese deleted successfully.");
      this.getDetail();
  })
}
  // on submit
  onSubmit(){  
    if(this.form.value.credentialUrl != null){
      var t = "https://www."; 
      var w = "www"; 
      if(this.form.value.credentialUrl.toString() != "" && !this.form.value.credentialUrl.toString().startsWith(t)&& !this.form.value.credentialUrl.toString().startsWith(w)){
        this.form.patchValue({
          credentialUrl : t +this.form.value.credentialUrl
        })
      } else if(this.form.value.credentialUrl.toString() != "" && this.form.value.credentialUrl.toString().startsWith(w)){  
        this.form.patchValue({
          credentialUrl : "https://" +this.form.value.credentialUrl
        })
      } 
    } 
    if(this.form.valid){
      if(this.editId){
        this.form.patchValue({
          id :this.editId
         })
        this.api.putData(apiUrl._updateLiences, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => {
          this.toastrService.success("", "licenese updated successfully.");
          this.getDetail();
          this.modalRef?.hide()
        })
      } else{
        delete this.form.value.id
          this.api.postData(apiUrl._addLiences, this.removeEmptyFiled(this.form))
          .subscribe(async (res) => {
            this.toastrService.success("", "licenese added successfully.");
            this.modalRef?.hide();
            this.getDetail();
          })
        }
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 3000);
    }
    
  }
  
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
}

